import { useQuery } from '@tanstack/react-query';
import { get } from '@/lib/api';
import { display } from '@/lib/utils';

export const SHIFT_TONE: Record<string, string> = {
  morning: 'border-warning/25 bg-warning/15 text-warning',
  evening: 'border-info/20 bg-info/10 text-info',
  night: 'border-primary/20 bg-primary/10 text-primary',
};

export const LEAVE_TONE = 'border-destructive/20 bg-destructive/10 text-destructive';

export interface DepartmentOption {
  id: string;
  name: string;
}

export function useDepartmentOptions(enabled: boolean) {
  return useQuery({
    queryKey: ['departments'],
    queryFn: () => get<DepartmentOption[]>('/org/departments'),
    enabled,
  });
}

export function isoDay(value: string): string {
  return value.slice(0, 10);
}

export function dayLabel(iso: string, parts: Intl.DateTimeFormatOptions = { weekday: 'short', day: 'numeric', month: 'short' }): string {
  return new Intl.DateTimeFormat(display.locale, { ...parts, timeZone: 'UTC' }).format(new Date(`${iso}T00:00:00.000Z`));
}

export function monthRange(month: string): { from: string; to: string } {
  const [year, monthIndex] = month.split('-').map(Number);
  const last = new Date(Date.UTC(year, monthIndex, 0)).toISOString().slice(0, 10);
  return { from: `${month}-01`, to: last };
}

export function currentMonth(): string {
  const now = new Date();
  return `${now.getFullYear()}-${String(now.getMonth() + 1).padStart(2, '0')}`;
}

export function minutesLabel(minutes: number): string {
  if (minutes <= 0) return '—';
  if (minutes < 60) return `${minutes} min`;
  const hours = Math.floor(minutes / 60);
  const rest = minutes % 60;
  return rest === 0 ? `${hours} h` : `${hours} h ${rest} min`;
}

export function hoursLabel(minutes: number): string {
  if (minutes <= 0) return '—';
  return `${(minutes / 60).toFixed(1)} h`;
}
